import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const COPY = defineMessages({
  CONTACT_US_TODAY: {
    id: 'Enterprise.copy.Heading',
    defaultMessage: 'Contact us today',
    desc: {
      id: 'Enterprise.copy.Heading',
      message: '[Type: header][Vis: high] - Primary header for enterprise tab contact us form',
      project: PROJECT_NAME,
    },
  },
  MAIN_HEADING: {
    id: 'Enterprise.copy.MainHeading',
    defaultMessage: 'Choose a plan that works for you',
    desc: {
      id: 'Enterprise.copy.MainHeading',
      message: '[Type: header][Vis: high] - Primary header for pricing enterprise page',
      project: PROJECT_NAME,
    },
  },
  SURVEY_MONKEY_ENTERPRISE: {
    id: 'Enterprise.copy.SurveyMonkeyEnterpriseHeading',
    defaultMessage: 'SurveyMonkey Enterprise',
    desc: {
      id: 'Enterprise.copy.SurveyMonkeyEnterpriseHeading',
      message: '[Type: header][Vis: high] - Primary header for enterprise user pricing page',
      project: PROJECT_NAME,
    },
  },
  LEARN_MORE: {
    id: 'Enterprise.copy.SubHeading',
    defaultMessage: 'Learn more about SurveyMonkey Enterprise and schedule a demo.',
    desc: {
      id: 'Enterprise.copy.SubHeading',
      message: '[Type: header][Vis: high] - Subheader for enterprise tab contact us form',
      project: PROJECT_NAME,
    },
  },
  MANAGE_USERS: {
    id: 'Enterprise.copy.ManageUsersBullet',
    defaultMessage:
      'Manage multiple users and gain visibility into all survey data collected across your organization with admin controls and dashboards.',
    desc: {
      id: 'Enterprise.copy.ManageUsersBullet',
      message: '[Type: paragraph][Vis: high] - First bullet for enterprise tab contact us form',
      project: PROJECT_NAME,
    },
  },
  CONFIDENTIAL_DATA: {
    id: 'Enterprise.copy.ConfidentialDataBullet',
    defaultMessage:
      'Ensure confidential data is protected with enhanced security including encryption, SSO, and features that help you remain compliant with HIPAA and GDPR.',
    desc: {
      id: 'Enterprise.copy.ConfidentialDataBullet',
      message: '[Type: paragraph][Vis: high] - Second bullet for enterprise tab contact us form',
      project: PROJECT_NAME,
    },
  },
  FEEDBACK: {
    id: 'Enterprise.copy.FeedbackBullet',
    defaultMessage:
      'Make feedback automated and actionable by connecting to key business systems using APIs and powerful integrations, including Salesforce, Marketo, Tableau, and more.',
    desc: {
      id: 'Enterprise.copy.FeedbackBullet',
      message: '[Type: paragraph][Vis: high] - Third bullet for enterprise tab contact us form',
      project: PROJECT_NAME,
    },
  },
  INVALID_EMAIL: {
    id: 'Enterprise.copy.Invalid-Email',
    defaultMessage: 'Please enter a valid email address',
    desc: {
      id: 'Enterprise.copy.Invalid-Email',
      message: '[Type: Form][Vis.: high] - A message that is shown if the email entered is invalid',
      project: PROJECT_NAME,
    },
  },
  BLOCKED_EMAIL: {
    id: 'Enterprise.copy.InvalidBusinessEmail',
    defaultMessage: 'Please use your business email address',
    desc: {
      id: 'Enterprise.copy.InvalidBusinessEmail',
      message: '[Type: Form][Vis.: high] - A message that is shown if a the email is not a business email',
      project: PROJECT_NAME,
    },
  },
  INVALID_PHONE_NUMBER: {
    id: 'Enterprise.copy.InvalidPhoneNumber',
    defaultMessage: 'Please enter your phone number',
    desc: {
      id: 'Enterprise.copy.InvalidPhoneNumber',
      message: '[Type: Form][Vis.: high] - A message that is shown if the phone number is not valid',
      project: PROJECT_NAME,
    },
  },
  REQUIRED: {
    id: 'Enterprise.copy.Required',
    defaultMessage: 'Required',
    desc: {
      id: 'Enterprise.copy.Required',
      message: '[Type: Form][Vis.: high] - A message that is shown if a field is required to process the form',
      project: PROJECT_NAME,
    },
  },
  CONTACT_SALES: {
    id: 'Enterprise.copy.ContactSales',
    defaultMessage: 'Contact sales',
    desc: {
      id: 'Enterprise.copy.ContactSales',
      message: '[Type: Button][Vis.: high] - A button/link text to contact the sales team',
      project: PROJECT_NAME,
    },
  },
  HUBSPOT_FORM_ERROR: {
    id: 'Enterprise.copy.BackendError',
    defaultMessage: 'Unable to load form.',
    desc: {
      id: 'Enterprise.copy.BackendError',
      message: '[Type: Button][Vis.: high] - A generic error message',
      project: PROJECT_NAME,
    },
  },
  ERROR: {
    id: 'Enterprise.copy.GenericError',
    defaultMessage: 'Error',
    desc: {
      id: 'Enterprise.copy.GenericError',
      message: '[Type: Button][Vis.: high] - A generic error message',
      project: PROJECT_NAME,
    },
  },
  CONSENT: {
    id: 'Enterprise.copy.ConsentMessage',
    defaultMessage: `Contact me about SurveyMonkey Business Solutions like product updates, news, information, and special promotions. I can unsubscribe <span id="subLink">here</span> at any time and can visit SurveyMonkey's <span id="privacyNotice">privacy notice</span> if I have any questions. We remember your preference so you do not have to submit it to us again and we will retain this preference until you opt-out.`,
    desc: {
      id: 'Enterprise.copy.ConsentMessage',
      message: '[Type: Text][Vis.: high] - Consent to newsletter subscription verbiage',
      project: PROJECT_NAME,
    },
  },
  CONSENT_FOR_SUBMISSION: {
    id: 'Enterprise.copy.ConsentMessageSubmission',
    defaultMessage: `Contact me about SurveyMonkey Business Solutions like product updates, news, information, and special promotions. I can unsubscribe if I have any questions. We remember your preference so you do not have to submit it to us again and we will retain this preference until you opt-out.`,
    desc: {
      id: 'Enterprise.copy.ConsentMessageSubmission',
      message: '[Type: Text][Vis.: high] - Consent to newsletter subscription verbiage submitted to hubspot',
      project: PROJECT_NAME,
    },
  },
});

export default COPY;
